import React from 'react';
import { connect } from 'react-redux';
import $ from 'jquery';
import moment from 'moment';

import ModalQuestion from '../../ModalQuestion';
import { cancelOffer } from '../../../redux/offers';
import { AnalyticsService } from '../../../services/AnalyticsService';
declare interface Props {
  offer: Offer;
  cancelOffer: Function;
  children: JSX.Element;
  business: Business;
  offers: any;
}

function CancelOffer(props: Props) {
  const id = `cancelOffer${props.offer.id}${props.offer.template_key}${props.offer.template_id}`;

  return (
    <>
      {React.cloneElement(props.children, {
        onClick: () => $('#' + id).modal('show'),
      })}
      <ModalQuestion
        title="Cancel Offer?"
        leftName="NO"
        rightName="YES"
        id={id}
        function={() => {
          AnalyticsService.track('Cancel offer', { name: props.offer.subtitle });
          props.cancelOffer(props.offer, props.offers.type);
        }}
      >
        {props.offer.subtitle},<br />
        {moment.parseZone(props.offer.starts_at).calendar()}
      </ModalQuestion>
    </>
  );
}

export default connect(({ business, offers }: StoreState) => ({ business, offers }), {
  cancelOffer,
})(CancelOffer);
